import api from './api';

export interface GapControl {
  _id: string;
  standard: string;
  identifier: string;
  description: string;
  category?: string;
  reference?: string;
  severity?: string;
  findings?: GapFinding[];
}

export interface GapFinding {
  _id: string;
  control: string | GapControl;
  systemInventory?: string;
  currentState: 'Compliant' | 'NonCompliant' | 'Partial' | 'NotApplicable';
  evidence?: string;
  remediationPlan?: string;
  status: 'Open' | 'InProgress' | 'Resolved' | 'Accepted';
  priority: 'Critical' | 'High' | 'Medium' | 'Low';
  assignedTo?: string;
  remediationDueDate?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface GapStats {
  totalFindings: number;
  openFindings: number;
  criticalFindings: number;
  remediationDue: number;
}

const gapAnalysisService = {
  // Get all controls
  async getControls(): Promise<GapControl[]> {
    const response = await api.get('/gap-analysis/controls');
    return response.data.data;
  },

  // Get single control
  async getControl(id: string): Promise<GapControl> {
    const response = await api.get(`/gap-analysis/controls/${id}`);
    return response.data.data;
  },

  // Create control
  async createControl(data: Partial<GapControl>): Promise<GapControl> {
    const response = await api.post('/gap-analysis/controls', data);
    return response.data.data;
  },

  // Get all findings
  async getFindings(): Promise<GapFinding[]> {
    const response = await api.get('/gap-analysis/findings');
    return response.data.data;
  },

  // Create finding
  async createFinding(data: Partial<GapFinding>): Promise<GapFinding> {
    const response = await api.post('/gap-analysis/findings', data);
    return response.data.data;
  },

  // Update finding
  async updateFinding(id: string, data: Partial<GapFinding>): Promise<GapFinding> {
    const response = await api.put(`/gap-analysis/findings/${id}`, data);
    return response.data.data;
  },

  // Delete finding
  async deleteFinding(id: string): Promise<void> {
    await api.delete(`/gap-analysis/findings/${id}`);
  },

  // Get dashboard stats
  async getStats(): Promise<GapStats> {
    const response = await api.get('/gap-analysis/stats');
    return response.data.data;
  }
};

export default gapAnalysisService;
